/* istanbul ignore file */
export { default } from './AddonCharacteristicModal';
